const BLOCKER_MESSAGE = `We noticed that you're using an ad blocker,
    which may adversely affect the performance and content on
    Bloomberg.com. For the best experience, please
    allowlist the site.`;

const BLOCKER_FOOTER_TEXT = `If you believe that you may have received
    this message in error <a href="https://www.bloomberg.com/feedback" style="color: #2B00F7" id="adBlockerFooterLink">please let
    us know</a>.`;

const LOGO_STYLES = [
    "font-family:BWHaasHead-95Black,BWHaasHead,Helvetica Neue,Helvetica",
    "font-size:45px",
    "margin:0 auto",
    "text-align:center",
    "color:white",
    "background-color:#2800D7",
    "padding:15px 0"
];

const MESSAGE_DIV_STYLES = [
    "font-size:18px",
    "line-height:28px",
    "background-color:white",
    "color:black",
    "padding: 20px",
    "font-family:Tiempos,Helvetica Neue,Helvetica"
];

const CONTAINER_STYLES = [
    "height:100%",
    "width:100%",
    "z-index:10000", // Set to 10_000 to take precedence over 9999 set on /graphics pages
    "color:white",
    "background:rgba(256,256,256,.8)",
    "position:fixed",
    "top:0",
    "left:0"
];

const ELEMENT_STYLES = [
    "min-width:300px",
    "border:2px solid #2800D7",
    "width:50%",
    "background-color:white",
    "color:black",
    "margin: 20vh auto"
];

const CONTINUE_DISPLAY_STYLES = [
    "background-color:#D8D8D8",
    "color:#000000",
    "font-size:20px",
    "text-align:center",
    "font-weight:bold",
    "font-family:BWHaasHead-75Bold,BWHaasHead,Helvetica Neue,Helvetica",
    "margin:0 auto 20px",
    "padding:5px",
    "width:165px"
];

const TIMER_STYLES = [
    "margin-left:4px",
    "display:inline-block",
    "border:1px solid #000000",
    "border-radius:100%",
    "color:#000000",
    "background-color:#D8D8D8",
    "font-size:20px",
    "text-align:center",
    "line-height:20px",
    "width:26px",
    "padding:3px"
];

const FAKE_AD_STYLES = [
    "width:1px !important",
    "height:1px !important",
    "position:absolute !important",
    "display:block",
    "top:-5000px",
    "left:-5000px;"
];

const FAKE_AD_CLASSES = [
    "pub_300x250",
    "pub_300x250m",
    "pub_728x90",
    "text-ad",
    "textAd",
    "text_ad",
    "text_ads",
    "text-ads",
    "text-ad-links"
];

const TEST_DIV_CLASSES = [
    "a-real-div-for-testing",
    "false-positive-test"
];

const TEST_DIV_STYLES = [
    "display: block",
    "position: absolute",
    "right: 200%",
    "height: 1%",
    "width: 1%"
];

const BLOCKER_FOOTER_STYLES = [
    "font-size:14px",
    "line-height:18px",
    "background-color:white",
    "color:black",
    "padding: 20px",
    "font-family:Tiempos,Helvetica Neue,Helvetica"
];

const FOOTER_ID = "adBlockerFooter";
const CONTAINER_ID = "adBlockerContainer";
const MESSAGE_ID = "adBlockerMessage";
const CONTINUE_LINK_ID = "adBlockerContinue";
const TIMER_ID = "adBlockerTimer";
const LOGO_ID = "adBlockerTitle";

export default class AdBlockerModal {

    static renderModal(message: string, duration: number | string) {
        const _document = document;

        const container = _document.createElement("aside");
        const element = _document.createElement("div");
        const logo = _document.createElement("h1");
        const logoText = _document.createTextNode("Bloomberg");
        const messageDiv = _document.createElement("div");
        const messageText = _document.createTextNode(message);
        const continueDisplay = _document.createElement("div");
        const continueDisplayText = _document.createTextNode("Continue");
        const timer = _document.createElement("div");
        const timerText = _document.createTextNode(duration as unknown as string);
        const footerDiv = _document.createElement("div");

        container.setAttribute("id", CONTAINER_ID);
        container.setAttribute("role", "dialog");
        container.setAttribute("aria-modal", "true");
        container.setAttribute("aria-labelledby", LOGO_ID);
        container.setAttribute("aria-describedby", MESSAGE_ID);
        logo.setAttribute("id", LOGO_ID);
        messageDiv.setAttribute("id", MESSAGE_ID);
        messageDiv.setAttribute("tabindex", "0");
        continueDisplay.setAttribute("id", CONTINUE_LINK_ID);
        continueDisplay.setAttribute("tabindex", "0");
        continueDisplay.setAttribute("role", "button");
        continueDisplay.setAttribute("aria-label", `Continue in ${ duration } seconds`);
        timer.setAttribute("id", TIMER_ID);
        timer.setAttribute("aria-live", "polite");
        timer.setAttribute("aria-atomic", "true");
        footerDiv.setAttribute("id", FOOTER_ID);

        logo.setAttribute("style", this.logoStyles());
        messageDiv.setAttribute("style", this.messageDivStyles());
        container.setAttribute("style", this.containerStyles());
        element.setAttribute("style", this.elementStyles());
        continueDisplay.setAttribute("style", this.continueDisplayStyles());
        timer.setAttribute("style", this.timerStyles());
        footerDiv.setAttribute("style", this.footerStyles());

        // Add keyboard handler for Enter/Space on continue button
        // Only triggers click if countdown has expired (timer is hidden)
        continueDisplay.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();

                if (timer.style.display === "none") {
                    continueDisplay.click();
                }
            }
        });

        logo.appendChild(logoText);
        messageDiv.appendChild(messageText);
        continueDisplay.appendChild(continueDisplayText);
        timer.appendChild(timerText);
        continueDisplay.appendChild(timer);
        footerDiv.innerHTML = BLOCKER_FOOTER_TEXT;

        // Get footer link after innerHTML is set
        const footerLink = footerDiv.querySelector("#adBlockerFooterLink") as HTMLElement | null;

        // Focus trap: cycle between messageDiv, continueDisplay, and optionally footerLink
        const focusableElements = [messageDiv, continueDisplay, footerLink].filter(Boolean) as HTMLElement[];
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        container.addEventListener("keydown", (event: KeyboardEvent) => {
            // Escape key handler - dismiss modal after countdown expires
            if (event.key === "Escape") {
                // Only allow Escape if timer is hidden (countdown has expired)
                if (timer.style.display === "none") {
                    event.preventDefault();
                    continueDisplay.click();
                }
            }

            // Tab key focus trap
            if (event.key === "Tab") {
                if (event.shiftKey) {
                    // Shift+Tab: moving backwards
                    if (document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    }
                } else if (document.activeElement === lastElement) {
                    // Tab: moving forwards
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        });

        element.appendChild(logo);
        element.appendChild(messageDiv);
        element.appendChild(continueDisplay);
        element.appendChild(footerDiv);
        container.appendChild(element);

        // Set initial focus to messageDiv after rendering
        setTimeout(() => {
            messageDiv.focus();
        }, 0);

        return container;
    }

    static getBlockerMessage() {
        return BLOCKER_MESSAGE;
    }

    static logoStyles() {
        return LOGO_STYLES.join("; ");
    }

    static messageDivStyles() {
        return MESSAGE_DIV_STYLES.join("; ");
    }

    static containerStyles() {
        return CONTAINER_STYLES.join("; ");
    }

    static elementStyles() {
        return ELEMENT_STYLES.join("; ");
    }

    static continueDisplayStyles() {
        return CONTINUE_DISPLAY_STYLES.join("; ");
    }

    static timerStyles() {
        return TIMER_STYLES.join("; ");
    }

    static fakeAdStyles() {
        return FAKE_AD_STYLES.join("; ");
    }

    static fakeAdClasses() {
        return FAKE_AD_CLASSES.join(" ");
    }

    static testDivStyles() {
        return TEST_DIV_STYLES.join("; ");
    }

    static testDivClasses() {
        return TEST_DIV_CLASSES.join(" ");
    }

    static footerStyles() {
        return BLOCKER_FOOTER_STYLES.join("; ");
    }

}
